import { render, staticRenderFns } from "./AgregarCamposGrid.vue?vue&type=template&id=c1037f70&"
import script from "./AgregarCamposGrid.vue?vue&type=script&lang=ts&"
export * from "./AgregarCamposGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c1037f70', component.options)
    } else {
      api.reload('c1037f70', component.options)
    }
    module.hot.accept("./AgregarCamposGrid.vue?vue&type=template&id=c1037f70&", function () {
      api.rerender('c1037f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/AgregarCamposGrid.vue"
export default component.exports